// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content{background-color:#fff;min-height:100vh;padding:200px 140px 87px;border-color:#cad0df}.registration-form{margin-top:54px}button.btn{margin-top:64px;min-width:260px}.footer-link{color:#8392a5}.registration-form iframe{margin-left:140px}.subtitle{text-align:center;margin-bottom:40px;margin-top:40px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
